import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PaymentBatchList from './List';
import PaymentBatchDetail from './Detail';

const defaultFields = {
    ApplicationType: { visible: true, label: '', required: false },
    AssessmentDate: { visible: true, label: '', required: true },
    Summary: { visible: true, label: '', required: true },
    ProjectOrders: { visible: true, label: '', required: false },
    OtherCumulativePrice: { visible: true, label: '', required: true },
    OtherAmountPaid: { visible: true, label: '', required: true },
    SubTotalRetain: { visible: true, label: '', required: true },
    LastPaymentCertificateAmount: { visible: true, label: '', required: true },
    OtherTaxAmount: { visible: false, label: '', required: false },
    PurchaseOrderNumber: { visible: false, label: '', required: false },
};

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const workflowItem = workflowsQA[wfid];
    const fields = { ...defaultFields };

    let configurableTypeFields = '';
    if (workflowItem.config.currentModelType === "Application") {
        if (placeholdersQA && placeholdersQA.ApplicationTypes) {
            configurableTypeFields = placeholdersQA.ApplicationTypes.values.filter(item => item.isActive === true).map(x => ({ value: x.field, display: x.display }));
        }
    }
    else if (workflowItem.config.currentModelType === "Certificate") {
        if (placeholdersQA && placeholdersQA.PaymentTypes) {
            configurableTypeFields = placeholdersQA.PaymentTypes.values.filter(item => item.isActive === true).map(x => ({ value: x.field, display: x.display }));
        }
    }

    fields.ApplicationType = { visible: configurableTypeFields != '', label: languageFile["GENERAL.FIELD.APPLICATIONTYPE"], required: configurableTypeFields != '' };
    fields.ApplicationType.configurableTypeFields = configurableTypeFields;

    fields.AssessmentDate = { visible: !!resources.AssessmentDayLabel, label: resources.AssessmentDayLabel || '', required: true };
    fields.Summary = { visible: !!resources.SummaryDetailsLabel, label: resources.SummaryDetailsLabel || '', required: true };

    //batchPaymentForPackagedContractEnabled
    fields.ProjectOrders = { visible: !!workflowsQA['72'] && contract.ispackaged, label: workflowsQA['72']?.notificationName, required: true };

    fields.OtherCumulativePrice = { visible: !!resources.CumulativePriceLabel, label: resources.CumulativePriceLabel || '', required: false };
    fields.OtherAmountPaid = { visible: !!resources.PlusAmountsSupplierLabel, label: resources.PlusAmountsSupplierLabel || '', required: false };
    fields.SubTotalRetain = { visible: !!resources.LessAmountsSupplierLabel, label: resources.LessAmountsSupplierLabel || '', required: false };
    fields.LastPaymentCertificateAmount = { visible: !!resources.LessAmountsDueLabel, label: resources.LessAmountsDueLabel || '', required: false };

    if (placeholdersQA.TaxEnabled) {
        const taxEnabled = placeholdersQA.TaxEnabled?.values
            .find(phItem => phItem.field === 'TaxEnabled').isActive;
            
        fields.OtherTaxAmount = {
            visible: taxEnabled,
            label: resources.TaxSupplierLabel || '',
            required: true
        };
    }

    if (placeholdersQA.PONumberEnabled) {
        const poNumberEnabled = placeholdersQA.PONumberEnabled?.values
            .find(phItem => phItem.field === 'PONumberEnabled').isActive;
            
        fields.PurchaseOrderNumber = {
            visible: poNumberEnabled,
            label: languageFile["CONTRACT.FIELD.PO_NUMBER"] || '',
            required: true
        };
    }

    // Allow placeholdersQA.Fields to override visibility/label/required
    if (placeholdersQA && placeholdersQA.Fields) {
        placeholdersQA.Fields.values.forEach(fieldItem => {
            const field = fields[fieldItem.field];
            if (field) {
                field.visible = fieldItem.isActive;
                field.label = fieldItem.display || field.label;
                field.required = fieldItem.isActive;
            }
        });
    }

    return fields;
}

class PaymentBatchRouter extends React.Component {
    constructor(props) {
        super(props);
        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <Routes caseSensitive>
                <Route path={workflowItem.paths.basePath} exact element={<Navigate replace to={workflowItem.paths.defaultPath} />} />
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<PaymentBatchList
                        {...this.props}
                        
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                    />}
                />
                <Route
                    path={'/:notificationid/*'}
                    element={<PaymentBatchDetail
                        {...this.props}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        
                    />}
                />

            </Routes>
        );
    }
};



export default PaymentBatchRouter;